import React from "react";
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
function InvestmentSwitch(){
    return(
        <div>
        <Header/>
        <section className="section-small">
        <div className="container-fluid">
            <h3>COMING SOON</h3>
            </div>
            </section>
        <Footer/>
      </div>
    )
}
export default InvestmentSwitch